import emitter from "tiny-emitter/instance";
import storage from "../helpers/storage";
import Regions from "../enums/Regions";
export var DEFAULT_REGION = Regions.EU;
var KEY = "pbregion";
var GLOBAL_TENANT_KEY = "pbglobaltenant";
var EVENT = "PB_REGION_UPDATE";
var Region = /** @class */ (function () {
    function Region() {
    }
    Region.prototype.set = function (value) {
        storage.setItem(KEY, value);
        emitter.emit(EVENT, value);
    };
    Region.prototype.get = function () {
        return storage.getItem(KEY) || "";
    };
    Region.prototype.setGlobalTenant = function (value) {
        storage.setItem(GLOBAL_TENANT_KEY, JSON.stringify(value));
        emitter.emit(EVENT, value);
    };
    Region.prototype.getGlobalTenant = function () {
        var tenant = { tenantId: "", subdomain: "", region: this.get() };
        try {
            tenant = JSON.parse(storage.getItem(GLOBAL_TENANT_KEY) || "");
        }
        catch (e) {
            // no-op
        }
        return tenant;
    };
    Region.prototype.addEventListener = function (cb) {
        emitter.on(EVENT, cb);
    };
    Region.prototype.removeEventListener = function (cb) {
        emitter.off(EVENT, cb);
    };
    return Region;
}());
export default new Region();
